import { motion } from 'framer-motion';
import { forwardRef } from 'react';

export const NexusCard = forwardRef(({ 
  children, 
  variant = 'glass',
  hover = true,
  glow = false,
  gradientBorder = false,
  className = '',
  onClick,
  ...props 
}, ref) => {
  const variants = {
    glass: 'glass-panel',
    solid: 'solid-card',
  };
  
  return (
    <motion.div
      ref={ref}
      whileHover={hover ? { y: -4, transition: { duration: 0.2 } } : {}}
      className={`
        relative rounded-lg overflow-hidden
        ${variants[variant]}
        ${glow ? 'glow-mint-hover' : ''}
        ${gradientBorder ? 'gradient-border' : ''}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
      {...props}
    >
      {children}
    </motion.div>
  );
});

NexusCard.displayName = 'NexusCard';

export const NexusCardHeader = ({ children, className = '' }) => (
  <div className={`p-6 pb-2 ${className}`}>
    {children}
  </div>
);

export const NexusCardTitle = ({ children, className = '' }) => (
  <h3 className={`font-heading text-xl font-semibold text-nexus-text-primary ${className}`}>
    {children}
  </h3>
);

export const NexusCardDescription = ({ children, className = '' }) => (
  <p className={`text-sm text-nexus-text-secondary mt-1 ${className}`}>
    {children}
  </p>
);

export const NexusCardContent = ({ children, className = '' }) => (
  <div className={`p-6 pt-4 ${className}`}>
    {children}
  </div>
);

export const NexusCardFooter = ({ children, className = '' }) => (
  <div className={`p-6 pt-0 flex items-center gap-3 ${className}`}>
    {children}
  </div>
);
